import { render } from "./BannerSkeleton.vue?vue&type=template&id=191f917c&scoped=true"
import script from "./BannerSkeleton.vue?vue&type=script&lang=js"
export * from "./BannerSkeleton.vue?vue&type=script&lang=js"

import "./BannerSkeleton.vue?vue&type=style&index=0&id=191f917c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191f917c"]])

export default __exports__